import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states = [{
    component: 'wtTriggerActionState',
    name: 'triggerAction',
    url: '/triggerAction',
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve,
        roles: Resolve.rolesResolve([
            Roles.administrator, Roles.master, Roles.engineer
        ])
    },
    data: {
        visible: false,
        editRoles: [Roles.engineer],
        editButtonVisibility: () => true,
        displayName: 'Workflow manager'
    }
}];

export default states;